// extracted by mini-css-extract-plugin
module.exports = {"blogNavigation":"BlogNavigation_blogNavigation__UXx3x","activeLink":"BlogNavigation_activeLink__c91rP"};